import React, { useEffect, useState } from "react";
import { Modal, Box, TextField, Button, Typography, Select, MenuItem } from "@mui/material";

const ModalEditarPrecioId = ({ open, handleClose, precioLista, onUpdate }) => {
  const [nuevoMonto, setNuevoMonto] = useState("");
  const [tipoAjuste, setTipoAjuste] = useState("valor"); // Default: valor absoluto

  useEffect(() => {
    console.log("precioLista", precioLista);
    if (precioLista) {
      setNuevoMonto(precioLista.costo || "");
    }
  }, [precioLista]);

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{ p: 4, bgcolor: "white", width: 400, margin: "auto", mt: 5 }}>
        <Typography variant="h6">Actualizar Monto</Typography>

        <Select
          value={tipoAjuste}
          onChange={(e) => setTipoAjuste(e.target.value)}
          fullWidth
          sx={{ my: 2 }}
        >
          <MenuItem value="valor">Actualizar por Valor</MenuItem>
          <MenuItem value="porcentaje">Actualizar por Porcentaje</MenuItem>
        </Select>

        <TextField
          label={tipoAjuste === "porcentaje" ? "Porcentaje (%)" : "Nuevo Monto"}
          type="number"
          value={nuevoMonto}
          onChange={(e) => setNuevoMonto(e.target.value)}
          fullWidth
          sx={{ my: 2 }}
        />

        <Button 
          variant="contained" 
          onClick={() => {
            onUpdate(precioLista.idItem, precioLista.idEntidad, precioLista.idUbicacion, parseFloat(nuevoMonto), tipoAjuste);
            handleClose();
          }}
          disabled={!nuevoMonto || isNaN(nuevoMonto)}
        >
          Guardar Cambios
        </Button>
      </Box>
    </Modal>
  );
};

export default ModalEditarPrecioId;
